export const config = {
  contact: {
    name: "Jesús de la Fuente",
    email: "jfuentelucas@gmail.com",
    socials: [
      {
        name: "LinkedIn",
        url: "https://www.linkedin.com/in/jesusdelafuente-dev/",
      },
      { name: "GitHub", url: "https://github.com/delafuentej" },
    ],
  },
};
